<section
  class="card card-highlight flex flex-col gap-3 p-5"
  data-testid="ai-profile-view"
  *transloco="let t; prefix: 'hrTool.aiProfile'"
>
  <div class="flex flex-col gap-1">
    <div class="flex items-center gap-2">
      <i class="pi pi-sparkles text-button-red text-lg"></i>
      <h2 class="m-0 text-base font-semibold" data-testid="ai-capabilities-header">
        {{ t('title', nameParams()) }}
      </h2>
      <app-directus-tooltip [tooltip]="t('selfDeclaration')" />
    </div>
    <p class="text-secondary m-0 text-sm">{{ t('description', nameParams()) }}</p>
  </div>

  @if (hasRows()) {
    <div class="flex flex-col">
      <div
        class="bg-second-level text-secondary hidden gap-3 rounded-lg px-3 py-2 text-xs md:grid"
        [ngClass]="gridColumns"
      >
        <span>{{ t('column.capability') }}</span>
        <span>{{ t('column.support') }}</span>
        <span>{{ t('column.level') }}</span>
        <span>{{ t('column.useCases') }}</span>
      </div>
      @for (row of rows(); track row.capability) {
        <div
          class="grid grid-cols-2 items-center gap-3 px-3 py-2"
          [ngClass]="gridColumns"
          [attr.data-testid]="row.testId"
        >
          <app-ai-capability-label
            class="col-span-2 text-sm md:col-span-1"
            [capability]="row.capability"
          />
          <app-ai-capability-dots [level]="row.level" />
          <app-ai-capability-level-label [level]="row.level" />
          <div class="col-span-2 flex flex-wrap gap-1 md:col-span-1">
            @if (row.hasUseCases) {
              @for (useCase of row.useCases; track $index) {
                <p-chip [label]="useCase" styleClass="text-xs" />
              }
            } @else {
              <span class="text-secondary">–</span>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <p class="text-secondary m-0 italic" data-testid="ai-profile-empty">{{ t('empty') }}</p>
  }
</section>
